import { useTranslation } from "react-i18next";
import { ReactComponent as AdministrarEmpresa } from "../../assets/images/administrar-empresa.svg";
import { ReactComponent as Combustible } from "../../assets/images/combustible.svg";
import { ReactComponent as OperadorMovil } from "../../assets/images/operador-movil.svg";
import { ReactComponent as Marca } from "../../assets/images/marca.svg";
import { ReactComponent as Modelo } from "../../assets/images/modelo.svg";
import { ReactComponent as ProveedorEquipo } from "../../assets/images/proveedor-equipo.svg";
import { ReactComponent as SimCard } from "../../assets/images/sim.svg";
import { ReactComponent as DispositivoRastreo } from "../../assets/images/dispositivo-rastreo.svg";
import { ReactComponent as Usuarios } from "../../assets/images/usuarios.svg";
import { ReactComponent as Grupo } from "../../assets/images/grupo.svg";
import { ReactComponent as SubGrupo } from "../../assets/images/subgrupo.svg";
import { ReactComponent as TipoVehiculo } from "../../assets/images/tipo-vehiculo.svg";
import { ReactComponent as Bateria } from "../../assets/images/bateria.svg";
import { ReactComponent as Traccion } from "../../assets/images/traccion.svg";
import { ReactComponent as Vehiculo } from "../../assets/images/vehiculo.svg";
import { ReactComponent as Instalacion } from "../../assets/images/instalacion.svg";
import { ReactComponent as Vendedores } from "../../assets/images/vendedores.svg";
import { ReactComponent as Moneda } from "../../assets/images/moneda.svg";
import { ReactComponent as Documentos } from "../../assets/images/documentos.svg";

export const useModulesAdminGroup = () => {
    const { t } = useTranslation();
    const GRUPOS_ADMINSTRACION = {
        ADMIN: t("label_administration"),
        VEHICLE: t("label_vehicle"),
        PROVIDER: t("label_provider"),
        USER: t("label_users"),
    };
    return GRUPOS_ADMINSTRACION;
};

export const useModulesAdmin = () => {
    const { t } = useTranslation();
    const GRUPOS_ADMINSTRACION = useModulesAdminGroup();
    const MODULES_ADMIN = [
        {
            id: 0,
            titulo: t("manage_fuel"),
            descripcion: t("label_fuel"),
            icono: <Combustible style={{ width: "40px", height: "40px", marginLeft: "12px" }} />,
            color: "rgba(0, 128, 0, 0.5)",
            href: "administer/manage-fuel/list-fuel",
            grupo: GRUPOS_ADMINSTRACION.VEHICLE,
        },
        {
            id: 1,
            titulo: t("mobile_carrier"),
            descripcion: t("label_provider"),
            icono: <OperadorMovil style={{ width: "40px", height: "40px", marginLeft: "12px" }} />,

            color: "rgba(0, 128, 0, 0.5)",
            href: "administer/manage-mobile-operador/list-mobile-operador",
            grupo: GRUPOS_ADMINSTRACION.PROVIDER,
        },
        {
            id: 2,
            titulo: t("vehicle_brand"),
            descripcion: t("label_brand"),
            icono: <Marca style={{ width: "40px", height: "40px", marginLeft: "12px" }} />,

            color: "rgba(0, 128, 0, 0.5)",
            href: "administer/manage-marca/list-marca",
            grupo: GRUPOS_ADMINSTRACION.VEHICLE,
        },
        {
            id: 3,
            titulo: t("vehicle_model"),
            descripcion: t("label_model"),
            icono: <Modelo style={{ width: "40px", height: "40px", marginLeft: "12px" }} />,

            color: "rgba(0, 128, 0, 0.5)",
            href: "administer/manage-model/list-model",
            grupo: GRUPOS_ADMINSTRACION.VEHICLE,
        },
        {
            id: 4,
            titulo: t("vehicle_equipment_provider"),
            descripcion: t("label_equipment_provider"),
            icono: <ProveedorEquipo style={{ width: "40px", height: "40px", marginLeft: "12px" }} />,
            color: "rgba(0, 128, 0, 0.5)",
            href: "administer/manage-equipment-provider/list-equipment-provider",
            grupo: GRUPOS_ADMINSTRACION.PROVIDER,
        },
        {
            id: 5,
            titulo: t("sim_card"),
            descripcion: t("label_sim_card"),
            icono: <SimCard style={{ width: "40px", height: "40px", marginLeft: "12px" }} />,
            color: "rgba(0, 128, 0, 0.5)",
            href: "administer/manage-sim/list-sim",
            grupo: GRUPOS_ADMINSTRACION.PROVIDER,
        },
        {
            id: 6,
            titulo: t("manage_company"),
            descripcion: t("label_manage_company"),
            icono: <AdministrarEmpresa style={{ width: "40px", height: "40px", marginLeft: "12px" }} />,
            color: "rgba(0, 128, 0, 0.5)",
            href: "administer/manage-company/list-company",
            grupo: GRUPOS_ADMINSTRACION.ADMIN,
        },
        {
            id: 7,
            titulo: t("manage_tracking_device"),
            descripcion: t("label_tracking_device"),
            icono: <DispositivoRastreo style={{ width: "40px", height: "40px", marginLeft: "12px" }} />,
            color: "rgba(0, 128, 0, 0.5)",
            href: "administer/manage-tracking-device/list-tracking-device",
            grupo: GRUPOS_ADMINSTRACION.PROVIDER,
        },
        {
            id: 8,
            titulo: t("manage_users"),
            descripcion: t("label_users"),
            icono: <Usuarios style={{ width: "40px", height: "40px", marginLeft: "12px" }} />,
            color: "rgba(0, 128, 0, 0.5)",
            href: "administer/manage-users/list-users",
            grupo: GRUPOS_ADMINSTRACION.USER,
        },
        {
            id: 9,
            titulo: t("manage_group"),
            descripcion: t("label_group"),
            icono: <Grupo style={{ width: "40px", height: "40px", marginLeft: "12px" }} />,
            color: "rgba(0, 128, 0, 0.5)",
            href: "administer/manage-group/list-group",
            grupo: GRUPOS_ADMINSTRACION.ADMIN,
        },
        {
            id: 10,
            titulo: t("manage_sub_group"),
            descripcion: t("label_sub_group"),
            icono: <SubGrupo style={{ width: "40px", height: "40px", marginLeft: "12px" }} />,
            color: "rgba(0, 128, 0, 0.5)",
            href: "administer/manage-sub-group/list-sub-group",
            grupo: GRUPOS_ADMINSTRACION.ADMIN,
        },
        {
            id: 11,
            titulo: t("manage_type_vehicle"),
            descripcion: t("label_type_vehicle"),
            icono: <TipoVehiculo style={{ width: "40px", height: "40px", marginLeft: "12px" }} />,
            color: "rgba(0, 128, 0, 0.5)",
            href: "administer/manage-tipo-vehiculo/list-tipo-vehiculo",
            grupo: GRUPOS_ADMINSTRACION.VEHICLE,
        },
        {
            id: 12,
            titulo: t("manage_voltaje_bateria"),
            descripcion: t("label_voltaje_bateria"),
            icono: <Bateria style={{ width: "40px", height: "40px", marginLeft: "12px" }} />,
            color: "rgba(0, 128, 0, 0.5)",
            href: "administer/manage-battery-voltage/list-battery-voltage",
            grupo: GRUPOS_ADMINSTRACION.VEHICLE,
        },
        {
            id: 13,
            titulo: t("manage_traccion"),
            descripcion: t("label_traccion"),
            icono: <Traccion style={{ width: "40px", height: "40px", marginLeft: "12px" }} />,
            color: "rgba(0, 128, 0, 0.5)",
            href: "administer/manage-vehicle-traction/list-vehicle-traction",
            grupo: GRUPOS_ADMINSTRACION.VEHICLE,
        },
        {
            id: 14,
            titulo: t("manage_vehicle"),
            descripcion: t("label_vehicle"),
            icono: <Vehiculo style={{ width: "40px", height: "40px", marginLeft: "12px" }} />,
            color: "rgba(0, 128, 0, 0.5)",
            href: "administer/manage-vehicle/list-vehicle",
            grupo: GRUPOS_ADMINSTRACION.VEHICLE,
        },
        {
            id: 15,
            titulo: t("manage_installation"),
            descripcion: t("label_vehicle_tracker_installation"),
            icono: <Instalacion style={{ width: "40px", height: "40px", marginLeft: "12px" }} />,
            color: "rgba(0, 128, 0, 0.5)",
            href: "administer/manage-installation/list-installation",
            grupo: GRUPOS_ADMINSTRACION.PROVIDER,
        },
        {
            id: 16,
            titulo: t("manage_secondary_client"),
            descripcion: t("label_secondary_client"),
            icono: <Usuarios style={{ width: "40px", height: "40px", marginLeft: "12px" }} />,
            color: "rgba(0, 128, 0, 0.5)",
            href: "administer/manage-cliente-secundario/list-cliente-secundario",
            grupo: GRUPOS_ADMINSTRACION.USER,
        },
        {
            id: 17,
            titulo: t("manage_sellers"),
            descripcion: t("label_sellers"),
            icono: <Vendedores style={{ width: "40px", height: "40px", marginLeft: "12px" }} />,
            color: "rgba(0, 128, 0, 0.5)",
            href: "administer/manage-sellers/list-sellers",
            grupo: GRUPOS_ADMINSTRACION.ADMIN,
        },
        {
            id: 18,
            titulo: t("manage_currency"),
            descripcion: t("label_manage_currency"),
            icono: <Moneda style={{ width: "40px", height: "40px", marginLeft: "12px" }} />,
            color: "rgba(0, 128, 0, 0.5)",
            href: "administer/manage-currency/list-currency",
            grupo: GRUPOS_ADMINSTRACION.ADMIN,
        },
        {
            id: 19,
            titulo: t("manage_documents_concepts"),
            descripcion: t("label_manage_document_concepts"),
            icono: <Documentos style={{ width: "40px", height: "40px", marginLeft: "12px" }} />,
            color: "rgba(0, 128, 0, 0.5)",
            href: "administer/manage-document-concept/list-documents",
            grupo: GRUPOS_ADMINSTRACION.VEHICLE,
        },
    ];

    return MODULES_ADMIN;
};
